import React from 'react'

function NeedHelp() {
    const openHelp = () => {
        document.getElementById('helpModal').style.display = 'block';
    }
    const closeHelp = () => {
        document.getElementById('helpModal').style.display = 'none';
    }

    window.addEventListener("click", function (event) {
        const modal = document.getElementById("helpModal");
        if (event.target === modal) {
        modal.style.display = "none";
        }
    });

  return (
    <div>
        <div className="need-help-layout">

        <aside className="need-help-sidebar">
            <div className="need-help-logo">HanbiroHR</div>

            <div className="need-help-menu">
            <div className="need-help-menu-main">
                <div className="need-help-menu-item">⏱ Timecard</div>

                <div className="need-help-menu-item need-help-menu-select need-help-menu-active active">✈ Vacation</div>
            </div>

            <div className="need-help-menu-section">My Vacation</div>
            <div className="need-help-menu-item">Request Vacation</div>
            <div className="need-help-menu-item">My Vacation Status</div>
            <div className="need-help-menu-item">Vacation Schedule</div>
            <div className="need-help-menu-item">View CC</div>
            <div className="need-help-menu-item">Request Settlement</div>

            <div className="need-help-menu-section">Manager Processing</div>
            <div className="need-help-menu-item">Vacation Adjust</div>
            <div className="need-help-menu-item">Vacation Approve</div>
            <div className="need-help-menu-item">Vacations Per User</div>
            <div className="need-help-menu-item">Settlement Management</div>

            <div className="need-help-menu-section">Admin Settings</div>
            <div className="need-help-menu-item need-help-menu-active active">Create Vacation</div>
            <div className="need-help-menu-item">Manager Settings</div>
            <div className="need-help-menu-item">Basic Settings</div>
            <div className="need-help-menu-item">Manager History</div>
            </div>
        </aside>


        <div className="need-help-main">


            <div className="need-help-header">
            <div className="need-help-header-left">☂ CREATE VACATION</div>

            <div className="need-help-header-right">
                <div className="need-help-header-help" onClick={openHelp}>Need Help</div>
                <div>ENGLISH</div>
                <div>🔔</div>
                <div>Move Old HR</div>
                <div>Phuong Dofu</div>
            </div>
            </div>


            <div className="need-help-content">

            <div className="need-help-tabs">
                <div className="need-help-tab-active">VACATIONS LIST</div>
                <div>CREATE VACATION</div>
            </div>

            <div className="need-help-toolbar">
                <div className="need-help-toolbar-left">
                <input className='need-help-toolbar-input' type="text" placeholder="Enter keyword to search" />
                <select className='need-help-toolbar-select'>
                    <option>All type</option>
                </select>
                </div>

            <div className="need-help-toolbar-right">
                <button className="need-help-btn-create need-help-btn-cre">+ Create</button>
                <button className="need-help-btn-create need-help-btn-rel">
                    <span className="need-help-reload"
                    title="Reload"
                    onClick={() => window.location.reload()}
                    >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 12a9 9 0 1 1-3-6.7"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"/>
                        <polyline points="21 3 21 9 15 9"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                    </span>
                </button>
            </div>
            </div>

            <table className="need-help-table">
                <thead>
                <tr>
                    <th>VACATION NAME</th>
                    <th>VACATION TYPE</th>
                    <th>TARGET</th>
                    <th>OCCUR DATE</th>
                    <th>OCCURRENCE CYCLE</th>
                    <th>EXPIRATION DATE</th>
                    <th>STATUS</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Annual Leave</td>
                    <td>Regular Vacation</td>
                    <td>All</td>
                    <td>Fiscal year</td>
                    <td>Every year</td>
                    <td>1 year(s) after occurrence</td>
                    <td className="need-help-status">Use</td>
                    <td>✏️ 🗑️</td>
                </tr>
                </tbody>
            </table>

            </div>
        </div>
        </div>


        <div id="helpModal" className="need-help-modal">
        <div className="need-help-modal-content">
            <span className="need-help-modal-close" onClick={closeHelp}>×</span>
            <iframe src="https://hanbiro.com/#/help-center"></iframe>
        </div>
        </div>
    </div>
  )
}

export default NeedHelp